/*
  Mobile search disclosure.

  Deliberately tiny and dependency-free: it toggles a panel that already contains the theme's own
  search markup, so the live-search behaviour (drv-live-search.js) is inherited rather than
  reimplemented. Opening and closing must never navigate - that is the whole point of the control.
*/
(function () {
  function init() {
    var toggle = document.querySelector('.drv-msearch-toggle');
    var panel = document.getElementById('drv-msearch-panel');
    if (!toggle || !panel) return;

    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = panel.querySelector('input[name="q"]');
        // Focus after the panel is laid out, otherwise iOS ignores it and the keyboard never opens.
        if (input) requestAnimationFrame(function () { input.focus(); });
      }
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();           // the control is a button, but guard against theme delegation
      setOpen(panel.hidden);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { setOpen(false); toggle.focus(); }
    });

    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (panel.contains(e.target) || toggle.contains(e.target)) return;
      setOpen(false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*
  Mobile menu: keyboard bridge.

  The hamburger is a <div> that the theme opens on click. It is now marked role="button" with a
  tab stop, so Enter and Space must do what a real button would - and aria-expanded has to stay
  truthful afterwards, including when the sidebar is closed by its own close control.

  It dispatches the SAME click the theme already listens for rather than reimplementing the
  open, so there is one behaviour and no second source of truth.
*/
(function () {
  function init() {
    var btn = document.querySelector(".js-mobile-menu.menu-bar");
    if (!btn || btn.dataset.drvKeyBound) return;
    btn.dataset.drvKeyBound = "1";

    btn.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") return;
      e.preventDefault();          // Space would otherwise scroll the page
      btn.click();
    });

    // The panel slides in from off-canvas, so its position is the honest signal of open state.
    var panel = document.querySelector(".box-menu-moible");
    if (!panel) return;
    var sync = function () {
      var r = panel.getBoundingClientRect();
      var open = r.left < window.innerWidth - 20 && r.right > 20;
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    };
    new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ["class", "style"] });
    document.addEventListener("click", function () { setTimeout(sync, 350); }, true);
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var r = panel.getBoundingClientRect();
      if (r.left < window.innerWidth - 20 && r.right > 20) {
        var close = document.querySelector(".js-close-sidebar");
        if (close) { close.click(); btn.focus(); }
      }
    });
    sync();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
